import { ATTENTE_REPONSE } from '@/configuration/optionBlocage/optionBlocage';
import { simulationEtatObtenu } from '@/api/devis/index';
import gestionWarningEtatObtenu from '@/services/devisCommandes/ligneCommande/gestionWarningEtatObtenu';
import { LOCATION } from '@/configuration/devisConf';

export default function simulationEtatObtenuAsync(ligneCommande, societeId) {
  const totalHtAvecLigneRemiseLoc = ligneCommande.lignesCommande
    .find(l => l.typeProduit === LOCATION)
    ?.totalHtAvecLigneRemise;
  const paramsSimulation = {
    id: ligneCommande.id ? ligneCommande.id : null,
    produitId: ligneCommande.produitId,
    anneeSemaine: ligneCommande.ligneReseau.anneeSemaine,
    qteFacesSouhaitees: ligneCommande.ligneReseau.qteFacesSouhaitees
      ? ligneCommande.ligneReseau.qteFacesSouhaitees : 0,
    etatSouhaite: ligneCommande.etatSouhaite,
    societeId: societeId,
    totalHtAvecLigneRemiseLocation: totalHtAvecLigneRemiseLoc,
  };
  ligneCommande.messagesAvertissement = null;
  simulationEtatObtenu(paramsSimulation).then((rslt) => {
    const resultSimulation = rslt.data.result;
    if (resultSimulation.etatDeLaDemande === true) {
      ligneCommande.etatProvisoire = ATTENTE_REPONSE;
    } else {
      ligneCommande.etatProvisoire = resultSimulation.etatObtenu;
      ligneCommande.rangOptionProvisoir = resultSimulation.rangOption;
    }
    if (resultSimulation.messagesAvertissement.length > 0) {
      ligneCommande.messagesAvertissement = gestionWarningEtatObtenu(
        resultSimulation.messagesAvertissement,
      );
    }
    ligneCommande.rangOption = resultSimulation.rangOption;
    ligneCommande.ligneReseau.qteFacesSouhaitees = resultSimulation.qteFacesSouhaitees;
  });
}
